import { FormSelect } from "react-bootstrap";

type inputprops = {
    [key: string]: any;
}
const DropDown = ({ name, register, required, children, ...attrs }: inputprops) => {
    if (register) {

        return (

            <FormSelect {...register(name, { required })} {...attrs}>
                {children}
            </FormSelect>
        )
    } else {
        return (
            <FormSelect {...attrs}>
                {children}
            </FormSelect>
        )
    }

}
export { DropDown }